import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Dashboard from "./Dashboard";
import UserList from "./UserList";
import BusinessUser from "./AddVideo";
import AddProduct from "./AddProduct";
import EditProduct from "./EditProduct";
import Jobs from "./Products";
import CategoryList from "./ChakraVideo";
import EditVideo from "./EditVideo";
import UpdatePassword from "./UpdatePassword";
import AddNewJob from "./AddVideo";
import Orders from "./Orders";

const DashboardLayout = ({ onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // Map URL paths to header titles
  const pathTitleMap = {
    "/dashboard": "Dashboard",
    "/dashboard/userlist": "User List",
    "/dashboard/video": "Chakra Content",
    "/dashboard/addvideo": "Add New Content",
    "/dashboard/edit-video": "Edit Content",
    "/dashboard/add-product": "Add New Product",
    "/dashboard/edit-product": "Edit Product",
    "/dashboard/product": "Products Management",
    "/dashboard/orders": "Orders",
    "/dashboard/changepass": "Change Password",
    "/dashboard/add-new": "Add New Job",
  };

  const [pageTitle, setPageTitle] = useState("Dashboard");

  useEffect(() => {
    const currentPath = location.pathname.toLowerCase();
    if (currentPath.startsWith("/dashboard/edit-video")) {
      setPageTitle("Edit Content");
      return;
    }
    if (currentPath.startsWith("/dashboard/edit-product")) {
      setPageTitle("Edit Product");
      return;
    }
    const title = pathTitleMap[currentPath] || "Dashboard";
    setPageTitle(title);
  }, [location]);

  return (
    <div className="flex min-h-screen bg-[#211436] text-white">
      {/* Sidebar */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        onLogout={onLogout}
        toggleSidebar={toggleSidebar}
      />

      {/* Main Section */}
      <div className="flex-1 flex flex-col bg-[#211436]">
        {/* Header */}
        <header className="p-4 flex items-center border-b border-white/10 bg-[#211436]">
          {/* Sidebar toggle (mobile) */}
          <button
            onClick={toggleSidebar}
            className="text-[#FE7A36] focus:outline-none md:hidden"
            aria-label="Toggle sidebar"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <h1 className="text-xl font-semibold ml-4 text-white">
            {pageTitle}
          </h1>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-6 bg-[#211436] overflow-auto">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/userlist" element={<UserList />} />
            <Route path="/addvideo" element={<BusinessUser />} />
            <Route path="/edit-video/:id" element={<EditVideo />} />
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/edit-product/:id" element={<EditProduct />} />
            <Route path="/product" element={<Jobs />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/video" element={<CategoryList />} />
            <Route path="/changepass" element={<UpdatePassword />} />
            <Route path="/add-new" element={<AddNewJob />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
